module.exports = __webpack_public_path__ + "img/emoji_shengli.9f3bbf8a.png";